import { render } from "./SVGLoader.vue?vue&type=template&id=ade48fc4&ts=true"
import script from "./SVGLoader.vue?vue&type=script&lang=ts"
export * from "./SVGLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__